import authSaga from './auth'

export default ({ run }) => {
  run(authSaga)
}
